import {createRoot} from "react-dom/client";
import "./i18n";
import "./index.scss";
import {Application} from "./Application";

if (module.hot) {
  module.hot.accept();
}


createRoot(document.getElementById("root")!).render(<Application />);
